import { BannerId } from '../../../typings/banners';
import { InternalTemplateResource } from '../../../typings/internalBanners';

export const CLEAR_INTERNAL_BANNER = 'CLEAR_INTERNAL_BANNER';
export type CLEAR_INTERNAL_BANNER = typeof CLEAR_INTERNAL_BANNER;

export interface ClearInternalBanner {
    type: CLEAR_INTERNAL_BANNER;
    bannerId: BannerId;
    resources?: InternalTemplateResource[];
}

export function clearInternalBannerAction(
    bannerId: BannerId,
    resources?: InternalTemplateResource[]
): ClearInternalBanner {
    return {
        type: CLEAR_INTERNAL_BANNER,
        bannerId,
        resources
    };
}
